import { BrowserQRCodeReader } from "@zxing/library";
$(function() {
	if (navigator.userAgent.indexOf("Cordova") !== -1) {
		$.cookie("Cordova", true, { path: "/", expires: 36500 });
	}
	$(document)
		.on("click", "#btn-login", function(e) {
			var form = $(this).parents("form");
			e.preventDefault();
			var inputs = form.find("input:visible");
			var valid = true;
			inputs.each(function(i, input) {
				var $input = $(input);
				if ($input.val() == null || $input.val() === "") {
					valid = false;
					var $inputContainer = $input.parents(".fg-line");
					$inputContainer.addClass("has-error");
					var $inputGroup = $input.parents(".input-group");
					if ($inputGroup.length === 0) {
						$inputContainer.addClass("animated shake");
					} else {
						$inputGroup.addClass("animated shake");
					}
				}
			});
			if (valid) {
				if (window.location.hash)
					form.attr("action", form.attr("action") + encodeURIComponent(window.location.hash));
				$("#needRedirect").val(localStorage.getItem("last-user-login") != null ? Boolean(localStorage.getItem("last-user-login") != window.Helper.String.hash($("#email").val())) : false );

				form.submit();
			}
			return false;
		}).on("change, keydown, keyup", ".has-error input", function(e) {
			$(this).parents(".has-error").removeClass("has-error");
		}).on("click", ".remove-login", function(e) {
			e.preventDefault();
			$.cookie("Login", null, { path: "/", expires: -1 });
			window.location.reload();
		}).on("click", "#goto-website", function(e) {
			e.preventDefault();
			$(".app-suggestion").hide();
			$("#l-login").removeClass("hide");
			$("#l-login").show();
			return false;
		}).on("click", "h4#logo-or-title", function (e) {
			$("#version-number").fadeToggle("medium");
		}).on("show.bs.modal", "#modal", function (e) {
			const codeReader = new BrowserQRCodeReader();
			codeReader
				.listVideoInputDevices()
				.then(videoInputDevices => {
					if (videoInputDevices.length === 0) {
						$("#modal").modal("hide");
						return;
					}
					codeReader.decodeFromVideoDevice(videoInputDevices[0].deviceId, "barcodeScannerVideo", (result, err) => {
						if (result) {
							$("#modal").modal("hide");
							window.location = window.Helper.Url.resolveUrl(`~/Home/Index?token=${result.text}`);
						}
					});
				})
				.catch(err => console.error(err));
		}).on("hidden.bs.modal", "#modal", function (e) {
			const stream = $("video")[0].srcObject;
			if(!!stream)
				stream.getTracks().forEach(x => x.stop());
		});
	if (!!window.plugins && !!window.plugins.waitingDialog) {
		window.plugins.waitingDialog.hide();
	}
});


window.addEventListener("load", () => {
	if (!document.getElementById("barcodeScanner")) return;
	const updateCameraStatus = () => window.navigator.mediaDevices.enumerateDevices()
		.then(value => value.filter(val => val.kind === "videoinput")
			.filter(devices => devices.label.search(/ir\s/i) === -1).length > 0 ? 
			document.getElementById("barcodeScanner").classList.remove("hidden") :
			document.getElementById("barcodeScanner").classList.add("hidden"));
	updateCameraStatus();
	navigator.mediaDevices.addEventListener("devicechange", updateCameraStatus);
});
